import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { withBlockExtensions } from '@plone/volto/helpers';
import cx from 'classnames';

const CardView = (props) => {
  const { className, data, isEditMode } = props;
  if (!data) return null;
  const target = data.href?.[0];

  if (!target || isEditMode)
    return (
      <section className={cx('item', 'junts-card', className)}>
        <h4>{data?.title || target?.title || ''}</h4>
      </section>
    );

  return (
    <MaybeWrap
      condition={!isEditMode}
      as={UniversalLink}
      href={target['@id']}
      className={cx('item', 'junts-card', className)}
    >
      <section>
        <h4>{data?.title || target?.title || ''}</h4>
      </section>
    </MaybeWrap>
  );
};

export default withBlockExtensions(CardView);
